import React from 'react';

function Modal(props) {
    function closeModal(e) {
        document.getElementById('modal').remove();
    }
    return (
        <div className="modal-window" id="modal">
            <div className="modal-header">
                <div className="modal-title">
                    <h3>{props.title}</h3>
                </div>
                <div className="modal-close">
                    <span className="modal-close-button" onClick={closeModal}>x</span>
                </div>
            </div>
            <div className="modal-body">
                {props.children}
            </div>
        </div>
    );
}

export default Modal;